import lottie from 'lottie-web';
document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.js-join-form');
    if (!form) return;

    const emailInput = form.querySelector('[name="email"]');
    const passwordInput = form.querySelector('[name="password"]');

    const registerStep = form.querySelector('.form-step-register');
    const verifyStep = form.querySelector('.form-step-verify');

    const userEmail = form.querySelector('.js-user-email');
    const verifyBtn = form.querySelector('.js-verify-code');
    const codeInputs = form.querySelectorAll('.code-inputs input');
    const codeError = form.querySelector('.js-code-error');

    const passwordToggle = form.querySelector('.js-password-toggle');
    const resendBtn = form.querySelector('.js-resend-btn');
    const resendTimer = form.querySelector('.js-timer');
    const resendTimerText = form.querySelector('.resend-timer');
    let resendTimerInterval = null;

    const SIGN_UP_URL = '/wp-json/stadami/v1/sign-up?platform=website';
    const CONFIRM_OTP_URL = '/wp-json/stadami/v1/confirm-otp';
    const USER_ME_URL = '/wp-json/stadami/v1/me';

    let secretKey = null;

    function setLoading(wrapper, isLoading) {
        if (!wrapper) return;

        if (isLoading) {
            wrapper.classList.add('loading');
        } else {
            wrapper.classList.remove('loading');
        }
    }

    async function sendLog(data) {
        try {
            await fetch('/wp-json/stadami/v1/log', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
        } catch (e) {
            console.log('Log failed');
        }
    }

    function startResendTimer(duration = 59) {
        if (!resendBtn || !resendTimer) return;

        let timeLeft = duration;

        clearInterval(resendTimerInterval);

        resendBtn.classList.add('disabled');

        if (resendTimerText) {
            resendTimerText.style.display = '';
        }

        resendTimer.textContent = `0:${String(timeLeft).padStart(2, '0')}`;

        resendTimerInterval = setInterval(function () {
            timeLeft--;

            resendTimer.textContent = `0:${String(timeLeft).padStart(2, '0')}`;

            if (timeLeft <= 0) {
                clearInterval(resendTimerInterval);

                resendTimer.textContent = '0:00';
                resendBtn.classList.remove('disabled');

                if (resendTimerText) {
                    resendTimerText.style.display = 'none';
                }
            }
        }, 1000);
    }

    function setError(input, message) {
        const group = input.closest('.form-group');
        const error = group.querySelector('.field-error');

        group.classList.add('has-error');
        error.textContent = message;
    }

    function clearError(input) {
        const group = input.closest('.form-group');
        const error = group.querySelector('.field-error');

        group.classList.remove('has-error');
        error.textContent = '';
    }

    function validateEmailLive() {
        const value = emailInput.value.trim();

        if (!value) {
            setError(emailInput, 'Please enter your email.');
            return false;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            setError(emailInput, 'Enter a valid email address.');
            return false;
        }

        clearError(emailInput);
        return true;
    }

    function validatePasswordLive() {
        const value = passwordInput.value;

        if (!value) {
            setError(passwordInput, 'Please enter a password.');
            return false;
        }

        if (value.length < 8) {
            setError(passwordInput, 'Must be at least 8 characters.');
            return false;
        }

        if (!/[A-Za-z]/.test(value) || !/[0-9]/.test(value)) {
            setError(passwordInput, 'Must contain numbers and letters.');
            return false;
        }

        if (!/[A-Z]/.test(value) && !/[^A-Za-z0-9]/.test(value)) {
            setError(passwordInput, 'Must contain uppercase or special symbols.');
            return false;
        }

        clearError(passwordInput);

        const group = passwordInput.closest('.form-group');
        group.classList.remove('show-hint');

        return true;
    }


    function showCodeError(message) {
        codeError.textContent = message;
        codeError.style.display = 'block';
        codeInputs.forEach(input => input.classList.add('has-error'));
    }

    function clearCodeError() {
        codeError.textContent = '';
        codeError.style.display = 'none';
        codeInputs.forEach(input => input.classList.remove('has-error'));
    }

    function getSecretKey(data) {
        return (
            data.secretKey ||
            data.secret_key ||
            data?.data?.secretKey ||
            data?.data?.secret_key
        );
    }

    let emailTouched = false;
    let passwordTouched = false;

    emailInput.addEventListener('input', function () {
        if (!emailTouched) return;
        validateEmailLive();
    });

    emailInput.addEventListener('blur', function () {
        emailTouched = true;
        validateEmailLive();
    });

    passwordInput.addEventListener('input', function () {
        if (!passwordTouched) return;
        validatePasswordLive();
    });

    passwordInput.addEventListener('focus', function () {
        passwordTouched = true;
        showPasswordHint(); // 👉 показали підказку
    });

    passwordInput.addEventListener('blur', function () {
        validatePasswordLive();
        hidePasswordHint(); // 👉 сховали
    });

    function isPasswordValidValue() {
        const value = passwordInput.value;

        return (
            value.length >= 8 &&
            /[A-Za-z]/.test(value) &&
            /[0-9]/.test(value) &&
            (/[A-Z]/.test(value) || /[^A-Za-z0-9]/.test(value))
        );
    }
    function showPasswordHint() {
        const group = passwordInput.closest('.form-group');

        if (group.classList.contains('has-error')) return;

        // якщо пароль вже валідний — hint не показуємо
        if (isPasswordValidValue()) {
            group.classList.remove('show-hint');
            return;
        }

        group.classList.add('show-hint');
    }

    function hidePasswordHint() {
        const group = passwordInput.closest('.form-group');
        group.classList.remove('show-hint');
    }

    form.addEventListener('submit', async function (e) {
        e.preventDefault();

        emailTouched = true;
        passwordTouched = true;
        const isEmailValid = validateEmailLive();
        const isPasswordValid = validatePasswordLive();
        const submitWrap = form.querySelector('.wrap-submit:not(.verify)');

        if (!isEmailValid || !isPasswordValid) return;
        try {
            setLoading(submitWrap, true);

            const response = await fetch(SIGN_UP_URL, {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: emailInput.value.trim(),
                    password: passwordInput.value,
                }),
            });

            const data = await response.json();

            console.log('Sign up response:', data);
            sendLog({
                step: 'sign-up',
                response: data
            });

            if (!response.ok) {
                const message = data.message || data.error || '';

                if (message.toLowerCase().includes('already')) {
                    setError(emailInput, 'This address is already in use.');
                } else {
                    setError(emailInput, message || 'Registration failed.');
                }

                return;
            }

            secretKey = getSecretKey(data);

            if (!secretKey) {
                setError(emailInput, 'Secret key was not returned from server.');
                return;
            }

            userEmail.textContent = emailInput.value.trim();

            registerStep.classList.remove('is-active');
            verifyStep.classList.add('is-active');
            startResendTimer(59);

            codeInputs[0]?.focus();

        } catch (error) {
            console.log('Sign up error:', error);
            setError(emailInput, 'Something went wrong. Please try again.');
        } finally {
            setLoading(submitWrap, false);
        }
    });

    verifyBtn.addEventListener('click', async function () {
        const verifyWrap = form.querySelector('.wrap-submit.verify');
        clearCodeError();

        const code = Array.from(codeInputs).map(input => input.value).join('');

        if (code.length !== 4) {
            showCodeError('Enter 4-digits code.');
            return;
        }

        if (!secretKey) {
            showCodeError('Secret key is missing. Please try registration again.');
            return;
        }

        try {
            setLoading(verifyWrap, true);

            const otpResponse = await fetch(CONFIRM_OTP_URL, {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    secretKey: secretKey,
                    secretCode: Number(code),
                }),
            });

            const otpData = await otpResponse.json();

            console.log('OTP response:', otpData);
            sendLog({
                step: 'otp',
                response: otpData
            });

            if (!otpResponse.ok) {
                showCodeError(otpData.message || otpData.error || 'Incorrect code. Try again.');
                return;
            }

            const accessToken = otpData?.access?.token;

            if (!accessToken) {
                showCodeError('Access token was not returned from server.');
                return;
            }

            const userResponse = await fetch(USER_ME_URL, {
                method: 'GET',
                headers: {
                    accept: 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            const userData = await userResponse.json();

            console.log('User me response:', userData);
            sendLog({
                step: 'user',
                response: userData
            });

            const promoCode = userData.subscriptionCode;

            if (promoCode) {
                sessionStorage.setItem('stadami_promo_code', promoCode);
            }

            window.location.href = '/registered/';

        } catch (error) {
            console.log('OTP/User error:', error);
            sendLog({
                step: 'error',
                message: error.message
            });

            showCodeError('Something went wrong. Please try again.');
        } finally {
            setLoading(verifyWrap, false);
        }
    });

    codeInputs.forEach((input, index) => {
        input.addEventListener('input', function () {
            this.value = this.value.replace(/\D/g, '');

            clearCodeError();

            if (this.value && codeInputs[index + 1]) {
                codeInputs[index + 1].focus();
            }
        });

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Backspace' && !this.value && codeInputs[index - 1]) {
                codeInputs[index - 1].focus();
            }
        });

        input.addEventListener('paste', function (e) {
            e.preventDefault();

            const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4);

            pasted.split('').forEach((number, i) => {
                if (codeInputs[i]) {
                    codeInputs[i].value = number;
                }
            });

            if (pasted.length === 4) {
                codeInputs[3].focus();
            }
        });
    });

    passwordToggle?.addEventListener('click', function () {
        passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
    });

    resendBtn?.addEventListener('click', async function () {
        if (this.classList.contains('disabled')) return;

        if (!secretKey) {
            showCodeError('Secret key is missing. Please try registration again.');
            return;
        }

        try {
            this.classList.add('disabled');

            sendLog({
                step: 'resend-start',
                secretKey: secretKey
            });

            const response = await fetch('/wp-json/stadami/v1/resend-otp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    secretKey: secretKey,
                }),
            });

            const data = await response.json();

            console.log('Resend response:', data);

            sendLog({
                step: 'resend-response',
                status: response.status,
                response: data
            });

            if (!response.ok) {
                showCodeError(data.message || data.error || 'Could not resend code.');
                this.classList.remove('disabled');
                return;
            }

            if (data.secretKey) {
                secretKey = data.secretKey;
            }

            clearCodeError();
            startResendTimer(59);

            sendLog({
                step: 'resend-success'
            });

        } catch (error) {
            console.log('Resend failed:', error);
            showCodeError('Could not resend code. Please try again.');

            sendLog({
                step: 'resend-exception',
                message: error.message
            });

            this.classList.remove('disabled');
        }
    });


    // lottie animation
    document.querySelectorAll('.js-lottie').forEach(el => {
        lottie.loadAnimation({
            container: el,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: el.dataset.animation
        });
    });

});